<template>
  <v-data-table
    :headers="tabela.headers"
    :items="relatorio[areaAttr]"
    :search="tabela.opcoes.pesquisa"
    :sort-by="tabela.opcoes.ordenarPor"
    :sort-desc="tabela.opcoes.decrescente"
    :items-per-page="5"
    item-key="id"
  >
    <template v-slot:top>
      <!-- Ordenação e Pesquisa -->
      <v-row>
        <v-col cols="12" md="4">
          <app-sort v-model="tabela.opcoes" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="4">
          <app-search v-model="tabela.opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- Total -->
    <template v-slot:[`body.append`]>
      <tr>
        <td align="center">
          <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
        </td>
        <td align="center">
          <strong>{{ totalAreas }}</strong>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { sum } from 'mathjs';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';

export default {
  name: 'TabelaResultadoInteresseArea',

  components: {
    AppSort,
    AppSearch,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    titulo: {
      type: String,
      required: true,
      default: '',
    },
    areaAttr: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tabela: {
        headers: [
          {
            text: `ÁREA DE ${this.titulo.toUpperCase()}`,
            value: 'nome',
            sortable: false,
          },
          {
            text: 'QUANTIDADE',
            value: 'quantidade',
            width: '15%',
            sortable: false,
            align: 'center',
          },
        ],
        opcoes: {
          pesquisa: '',
          decrescente: true,
          ordenarPor: 'quantidade',
          selecionado: { id: 'quantidade', descricao: 'Quantidade' },
          lista: [
            { id: 'nome', descricao: `Área de ${this.titulo}` },
            { id: 'quantidade', descricao: 'Quantidade' },
          ],
        },
      },
    };
  },

  computed: {
    totalAreas() {
      return sum(this.relatorio[this.areaAttr].length > 0 ? this.relatorio[this.areaAttr].map((a) => a.quantidade) : 0);
    },
  },
};
</script>
